/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWGameResponse } from './OWGameResponse';
import {
    OWGameResponseFromJSON,
    OWGameResponseFromJSONTyped,
    OWGameResponseToJSON,
    OWGameResponseToJSONTyped,
} from './OWGameResponse';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface SearchEnhancedGamesResponse
 */
export interface SearchEnhancedGamesResponse {
    /**
     * 
     * @type {Array<OWGameResponse>}
     * @memberof SearchEnhancedGamesResponse
     */
    data: Array<OWGameResponse>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof SearchEnhancedGamesResponse
     */
    paginationInfo: PaginationInfo;
}

/**
 * Check if a given object implements the SearchEnhancedGamesResponse interface.
 */
export function instanceOfSearchEnhancedGamesResponse(value: object): value is SearchEnhancedGamesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    return true;
}

export function SearchEnhancedGamesResponseFromJSON(json: any): SearchEnhancedGamesResponse {
    return SearchEnhancedGamesResponseFromJSONTyped(json, false);
}

export function SearchEnhancedGamesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchEnhancedGamesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(OWGameResponseFromJSON)),
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
    };
}

export function SearchEnhancedGamesResponseToJSON(json: any): SearchEnhancedGamesResponse {
    return SearchEnhancedGamesResponseToJSONTyped(json, false);
}

export function SearchEnhancedGamesResponseToJSONTyped(value?: SearchEnhancedGamesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(OWGameResponseToJSON)),
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
    };
}

